import { isEqual, isObjectLike, union, keys } from 'lodash'

function getChanges (obj1, obj2, ignorePaths = []) {
  const result = {}

  function compare (o1, o2, path = '') {
    if (ignorePaths.includes(path || '.')) {
      return
    }
    const objKeys = union(keys(o1), keys(o2))
    const keysThatChanged = []

    for (const key of objKeys) {
      const currentPath = path ? `${path}.${key}` : key

      if (ignorePaths.includes(currentPath)) continue

      const has1 = o1 && Object.hasOwnProperty.call(o1, key)
      const has2 = o2 && Object.hasOwnProperty.call(o2, key)

      // Inserción o eliminación
      if (!has1 || !has2) {
        keysThatChanged.push(key)
        continue
      }

      const val1 = o1[key]
      const val2 = o2[key]

      if (!isEqual(val1, val2)) {
        keysThatChanged.push(key)
      }
    }

    // Bail out si todos han cambiado
    if (keysThatChanged.length === objKeys.length && objKeys.length > 0) {
      result[path || '.'] = { value: o2, oldValue: o1 }
      return
    }

    // Recursar solo las claves cambiadas
    for (const key of keysThatChanged) {
      const currentPath = path ? `${path}.${key}` : key
      if (ignorePaths.includes(currentPath)) continue

      const val1 = o1?.[key]
      const val2 = o2?.[key]

      if (isObjectLike(val2) && isObjectLike(val1)) {
        compare(val1, val2, currentPath)
      } else {
        result[currentPath] = { value: val2, oldValue: val1 }
      }
    }
  }

  compare(obj1, obj2)
  return result
}

export default getChanges
